import LegalPage from "./LegalPage";

const BACKGROUND_IP_SECTIONS = [
  {
    heading: "Statement of background IP",
    body: [
      "All methodologies, frameworks, naming conventions, visual systems, learning gates, governance architectures and toolkit materials developed by Bigibila Consultancy are asserted as background intellectual property of Bigibila Consultancy.",
    ],
  },
  {
    heading: "Assets covered",
    body: [
      "Background IP includes (but is not limited to) the following named assets, which are trademarks (registered or asserted) of Bigibila Consultancy:",
      "• Bigibila Advisory Method™ — the underlying advisory methodology.",
      "• Lore-Led Architecture™ — the design approach in which software answers to Lore (Aboriginal authority).",
      "• Aboriginal Governance Architecture Model™ (AGAM) — the structural governance model.",
      "• AGAM Toolkit™ — the productised set of toolkit components.",
      "• Lore-Gate™ — the permissions checkpoint engine.",
      "• Q-Level Escalation™ — the protected escalation ladder.",
      "• Girribal learning gates — the cultural learning-as-access pattern.",
      "• The BIG-series toolkit codes (BIG-GOV-001, BIG-ICIP-002, BIG-IDS-003, BIG-FPIC-004, BIG-UNDRIP-005, BIG-AUDIT-006, BIG-PILOT-007) and the productised packs they refer to.",
    ],
  },
  {
    heading: "Use of background IP in engagements",
    body: [
      "When Bigibila Consultancy is engaged on a project, the background IP listed above remains the property of Bigibila Consultancy. The client receives a licensed right to use the deliverables produced from that IP within the agreed scope, but does not acquire ownership of the IP itself.",
      "Any foreground IP (project-specific outputs) and the treatment of any community-supplied material will be addressed in the engagement agreement.",
    ],
  },
  {
    heading: "Artwork by Briana Pitt — protected artistic IP",
    body: [
      "The visual artwork featured across BIGIBILA SYSTEMS™ — including the Welcome page illustration, brand artefacts and supporting graphics — is the original creative work of Briana Pitt, a First Nations artist. All rights in that artwork remain with the artist.",
      "The artwork is used with the artist's permission for BIGIBILA SYSTEMS™ and may not be copied, reproduced, redistributed, sub-licensed, adapted, used to train artificial intelligence systems, or otherwise exploited without the artist's prior written consent.",
      "This protection sits alongside, and does not limit, any Indigenous Cultural and Intellectual Property (ICIP) rights held collectively by community.",
    ],
  },
  {
    heading: "No use without agreement",
    body: [
      "The background IP listed here may not be copied, reproduced, redistributed, sub-licensed, used as the basis for derivative work, or used to train artificial intelligence systems without a prior written agreement with Bigibila Consultancy.",
    ],
  },
  {
    heading: "Contact",
    body: [
      "For licensing enquiries or to discuss the treatment of background IP within a proposed engagement, contact us at info@bigibilasystems.com.",
    ],
  },
];

export default function BackgroundIP() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Background IP Notice"
      lastUpdated="DRAFT — Feb 2026"
      sections={BACKGROUND_IP_SECTIONS}
    />
  );
}
